import React from 'react';
import { useAuth0 } from '../../../contexts/react-auth0-spa';
import NonAuthenticated from './NonAuthenticated';
import Authenticated from './Authenticated';

const NavBarContainer = (props: any) => {
	const { isAuthenticated } = useAuth0();
	// eslint-disable-next-line react/jsx-props-no-spreading
	return isAuthenticated ? <Authenticated {...props} /> : <NonAuthenticated />;
};

export default NavBarContainer;
